import React from "react";
import { useLocation, Link } from "react-router-dom";
import { LEGAL } from "@/data/site";
import PageHero from "@/components/PageHero";
import Breadcrumb from "@/components/Breadcrumb";

export default function Legal() {
  const { pathname } = useLocation();
  const page = pathname.split("/").filter(Boolean).pop();
  const content = LEGAL[page];

  if (!content) {
    return (
      <div className="empty-state">
        <h2>Page introuvable</h2>
        <Link to="/" className="btn-primary">Retour à l'accueil</Link>
      </div>
    );
  }

  return (
    <>
      <PageHero tag="Informations légales" title={content.title} />
      <Breadcrumb trail={[{ label: "Accueil", to: "/" }, { label: content.title }]} />

      <section className="prose-section" data-testid="legal-content">
        {content.blocks.map((b, i) => (
          <div key={i}>
            <h2>{b.h}</h2>
            <p>{b.p}</p>
          </div>
        ))}
        <p style={{ marginTop: "2rem", fontSize: "0.8rem", color: "var(--muted)" }}>
          Dernière mise à jour : janvier 2026.
        </p>
      </section>
    </>
  );
}
